<template>
  <div class="relative cursor-pointer " :style="getStyle" @click="videoClicked">
    <div class="absolute flex flex-wrap content-between h-full w-full">
      <div class="flex w-full top-panel-background p-1">
        <!--  <div class="w-1/6 overflow-hidden">
          <div class="bg-black rounded-full">
            <img
              :src="marker"
              loading="lazy"
              alt="marker icon"
              class="white-marker-image p-1 md:p-3"
            />
          </div>
        </div> -->
        <!-- contributor.country} ${contributor.name} ${contributor.generation} ${contributor.discipline}`; -->
        <div class="w-full flex items-center">
          <div>
            <div class="w-full" :class="getCSS">
              {{ getContributor.country + ", " + getContributor.name }}
            </div>
            <div class="w-full" :class="getCSS">
              {{ getContributor.generation + ", " + getContributor.discipline }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-full bg-black text-white py-2 px-1 md:px-2 select-none"
        :class="getCSS"
      >
        {{ video.question }}
      </div>
    </div>
    <img
      :src="video.videoStillImage.url"
      loading="lazy"
      class="main-background"
      alt="Video still image"
    />
  </div>
</template>

<style scoped>
.main-background {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.white-marker-image {
  transform: scale(2);
}

.top-panel-background {
  background: #61d39c;
}

.text-xs {
  font-size: 0.6em;
}
</style>

<script>
import { mapMutations, mapGetters } from "vuex";
// Import assets
import marker from "../assets/marker-white-icon.png";
import { getID } from "../utilities";

export default {
  props: {
    video: Object,
  },
  mounted() {
    // console.log(this.video);
  },
  computed: {
    ...mapGetters(["getIsMobile"]),
    getCSS() {
      if (this.getIsMobile) return "text-xs";
      else return "text-base";
    },
    getStyle() {
      if (this.getIsMobile) return "height: 200px; width: 150px;";
      else return "height: 400px; width: 300px;";
    },
    getContributor() {
      const contributor = this.video.contributor;
      return contributor;
    },
  },
  data() {
    return {
      show: false,
      marker,
    };
  },
  methods: {
    ...mapMutations(["setVideo"]),
    buttonClicked(str) {
      console.log(str + " clicked");
    },
    videoClicked() {
      const id = getID(this.video.video.url);
      this.$router.push(`/video/${id}`);
    },
  },
};
</script>
